import useGetNewsTipInitialValues from './useGetNewsTipInitialValues'

export default useGetNewsTipInitialValues
